<template>
  <div class="box">
    <div class="questions">
      <v-list>
        <template v-for="(question, index) in questions">
          <v-list-item v-bind:key="index">
            <v-list-item-content>
              <v-list-item-title
                v-text="question.questionText"
              ></v-list-item-title>
              <v-list-item-subtitle>
                <p>
                  <span
                    >Frage von: {{ getUserForId(question.askedById) }},
                    {{
                      question.createdDate | moment("DD.MM.YYYY HH:mm")
                    }}</span
                  >
                </p>
              </v-list-item-subtitle>
              <v-list-item-title
                v-if="question.questionAnswer"
                v-text="question.questionAnswer"
              ></v-list-item-title>
              <v-list-item-subtitle v-if="question.questionAnswer">
                <p>
                  <span
                    >Antwort von: {{ getUserForId(question.assignee) }},
                    {{
                      question.answeredDate | moment("DD.MM.YYYY HH:mm")
                    }}</span
                  >
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="question.id" class="ma-0 pa-0" />
        </template>
      </v-list>
    </div>
    <div class="newQuestion">
      <div style="position: absolute; left: 25px; top: 0px; right: 75px">
        <p class="errorText" v-if="isError"><v-icon color="primary">mdi-alert</v-icon> Bitte füllen Sie alle Felder aus</p>
        </div>
      <div style="position: absolute; left: 25px; top: 25px; right: 75px">
        <v-select
        label="An wen wird die Frage gestellt?"
                v-model="assignee"
                :items="users"
                item-text="fullName"
                item-value="userId"
              ></v-select>
      </div>
      <div
        style="
          position: absolute;
          left: 25px;
          bottom: 0;
          top: 90px;
          right: 75px;
        "
      >
        <v-text-field
          v-model="questionText"
          label="Fragetext"
          outlined
        ></v-text-field>
      </div>
      <div
        style="position: absolute; right: 0; bottom: 0; top: 90px; width: 75px"
      >
        <v-btn
          @click="saveQuestion"
          class="mx-2"
          fab
          dark
          small
          color="primary"
        >
          <v-icon dark>mdi-send</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import questionService from "./question-service";
import processModelingService from "@/pages/ProcessModeling/process-modeling-service"
export default {
  components: {},
  props: {
    uuid: String,
    elementId: String,
  },
  data: function () {
    return {
      questionText: null,
      assignee: null,
      questions: [],
      users: [],
      isError: false
    };
  },
  mounted: function () {
    this.retrieveQuestions(this.uuid, this.elementId);
    this.retrieveUsers();
  },
  watch: {
    elementId: function (val) {
      this.retrieveQuestions(this.uuid, val);
    },
  },
  methods: {
    saveQuestion() {
      if(this.assignee == null || this.questionText == null || this.questionText == ""){
        this.isError = true;
      }else{
        
        questionService
        .saveQuestion(
          this.uuid,
          this.elementId,
          this.questionText,
          this.assignee
        )
        .then(() => {
          this.isError = false;
          this.questionText = null;
          this.assignee = null;
          this.retrieveQuestions();
          this.retrieveUsers();
        });
      }
    },
    retrieveQuestions() {
      questionService
        .retrieveQuestions(this.uuid, this.elementId)
        .then((result) => {
          this.questions = result.data;
        });
    },
    retrieveUsers(){
      processModelingService.retrieveAllUsers().then(allUsers => {
          allUsers.data.forEach( user => {
              user.fullName = user.firstName+' '+user.lastName;
              this.users.push(user);
          })
        });
    },
    getUserForId(userId){
      return this.users.find(user => user.userId == userId).fullName;
    }

  },
};
</script>
<style scoped>
.errorText{
  color: var(--v-primary-base);
  font-size: 0.85rem;
}
.questions,
.newQuestion {
  position: absolute;
}
.questions {
  top: 0;
  left: 0;
  right: 0;
  bottom: 180px;
  overflow-y: auto;
}
.newQuestion {
  bottom: 0;
  right: 0;
  left: 0;
  height: 160px;
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.disable-events {
  pointer-events: none
}
</style>